<template>
  <div class="min-h-screen">
    <!-- HEADING -->
    <div class="lg:h-72 flex justify-start items-end p-12 bg-gray-200">
      <div
        class="h-32 border-l-4 pl-6 border-black flex flex-col justify-end items-end m-0 p-0 w-full"
      >
        <h1 class="w-full text-left">Media</h1>
        <span class="text-md w-full text-left"
          >Manage your media files, images and videos</span
        >
      </div>
    </div>

    <!-- CONTENT -->
    <div
      class="bg-truegray-700 w-full pb-16 flex flex-col items-center lg:items-start"
    >
      <div
        class="bg-white rounded-xl lg:ml-16 mt-16 relative z-20 w-11/12 lg:w-9/12 min-h-screen"
      >
        <MediaItems />
      </div>
    </div>
  </div>
</template>

<script>
import MediaItems from '../../../../../shared/tenant/MediaItems.vue'

export default {
  components: {
    MediaItems,
  },

  props: {},

  data() {
    return {
      infoClass:
        'absolute left-full top-0 w-64 z-50 border border-truegray-300 rounded p-4 opacity-0 transition-all duration-300 transform pointer-events-none shadow group-hover:opacity-100 bg-white',
      inputTextClass:
        'flex-grow px-4 mr-0 mt-1 outline-none focus:outline-none bg-transparent w-full h-12 font-primary text-black focus:placeholder-truegray-300',
      inputLabelClass:
        'absolute transform duration-100 ease-linear px-1 left-3 top-1 z-40 text-truegray-700',
    }
  },
}
</script>
